import { render, staticRenderFns } from "./sourceinputblock.vue?vue&type=template&id=3427fb19"
import script from "./sourceinputblock.vue?vue&type=script&lang=ts"
export * from "./sourceinputblock.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports